export const ALL     = 'all';
export const REPRINT = 'reprint';
export const NONE = 'None';

// ONLINE AISLE ==================
export const CUT    = 'cut';
export const PACKED = 'packed';
export const PACKING = 'packing';
export const PTO = 'pto';
export const MTO = 'mto';

// OA Hold Parameters
export const DIE_IS_NOT_AVAILABLE      = "Die is not available";
export const MATERIAL_IS_NOT_AVAILABLE = "Material is not available";
export const MISSING_BILLING           = "MISSING_BILLING"
export const MISSING_DUE_DATE          = "MISSING_DUE_DATE"
export const MISSING_DELIVERY_DATE     = "MISSING_DELIVERY_DATE"
export const MISSING_DATES             = "MISSING_DATES";
// OA Batch Parameters
export const BATCH_CUTTING = 'batch_cutting';
export const DIE           = 'die';
export const MATERIAL      = 'material';
export const QTY           = 'qty';
export const NO_BATCHES    = 'no_batches';
export const SCRAP         = 'scrap';

// Dashboard Statuses
export const HOLD             = 'hold';
export const PENDING_PRINTING = 'pending_printing';
export const PREPRESS         = 'prepress';
export const PRINT_READY      = 'printready';
export const PRINTED          = 'printed';
export const PRINTING_ABORTED = 'printing_aborted';
export const PROCESSING       = 'processing';
export const PREPRINT         = 'preprint';
export const QUEUED           = 'queued';
export const SHIPMENTS        = 'shipping';
export const EOD_FAILED       = 'eod_failed';
export const EOD_COMPLETED    = 'eod_completed';
export const COMMENT          = 'comment';
export const RELEASE_CS       = 'release_cs';
export const UNCANCELLED      = 'uncancelled';
export const GHS_PRINT_PENDING= 'ghs_print_pending';

// Batch Statuses
export const OPEN            = 'open';
export const PRINTING        = 'printing';
export const SEALED_PRINTING = 'sealed_printing';
export const RUSH            = 'rush';
export const SEALED          = 'sealed';
export const ONLASER         = 'on_laser';
export const LOCKED          = 'locked';
export const CLOSED          = 'closed';
export const COMPLETED       = 'completed';

// Hold Statuses
export const CSHOLD      = 'cshold';
export const CSAPPROVAL  = 'csapproval';
export const DIENOTAVAILABLE ='dienotavailable';
export const PRODPENDING = 'prodpending';
export const QA          = 'qa';
export const ENGINEERING = 'engineering';
export const MATERIALNOTAVAILABLE ='materialnotavailable';
export const OTHER       = 'other';
export const DPO         = 'DPO';
export const SYSTEMS     = 'systems';
export const SHIPPING    = 'shipping';
export const SWITCHSYSTEMFAILURE = 'switchsystemfailure';

// Shipment Statuses
export const NEW       = 'new';
export const READY     = 'qaok';
export const BOXED     = 'boxed';
export const SHIPPED   = 'shipped';
export const CONFIRMED = 'confirmed';
export const CANCELLED = 'cancelled';

// Shipment Service Filter Param
export const SERVICE = 'service';
export const DELIVERYDATE = 'delivery';
export const CUSTOMERDUE = 'customerDue';
export const DUEDATE = 'due';
export const DAYSUNTILDUE = 'daysUntilDue';

// Shipment Carrier Types
export const AMAZON = 'AMAZON';
export const UPS = 'UPS';
export const FEDEX = 'FEDEX';

// Scanner Types
export const HANDHELD   = 'handheld';
export const STATIONARY = 'stationary';
export const ID_CARD    = 'id_scan';
export const ACCESSORY  = 'accessory';
export const RFID       = 'rfid';
export const LAMINATION = 'lamination';
//Preferred Cutting Types
//export const DIE = 'Die';
export const LASER = 'laser';

// RFID ==================
export const COLLATING  = 'collating';
export const COLLATED  = 'collated';
export const FINISHING  = 'finishing';
export const FINISHED  = 'finished';
export const LAMINATING  = 'laminating';
export const LAMINATED  = 'laminated';
export const VALIDATING  = 'validating';
export const VALIDATED  = 'validated';


export const batchStatusTypes = [
  // ALL
  CANCELLED,
  OPEN,
  HOLD,
  SEALED,
  PRINTING,
  PRINTED
];

export const holdStatusTypes = [
  // ALL
  CSHOLD,
  CSAPPROVAL,
  PRODPENDING,
  QA,
  SYSTEMS,
  REPRINT,
  ENGINEERING,
  OTHER,
  DPO,
  DIENOTAVAILABLE,
  MATERIALNOTAVAILABLE,
  SHIPPING,

  //Used within HOLD LIST
  DIE_IS_NOT_AVAILABLE,
  DIE,
  MATERIAL_IS_NOT_AVAILABLE,
  MATERIAL
];

export const statusTypes = [
  // CANCELLED,
  // ALL
  PREPRESS,
  HOLD,
  // PROCESSING,
  QUEUED,
  PRINTING_ABORTED,
  PRINT_READY,
  PRINTED,
  SHIPMENTS
];

export const oaStatusTypes = [
  // CANCELLED,
  // ALL
  HOLD,
  PREPRINT,
  PRINT_READY,
  QUEUED,
  CUT,
  PACKING,
  SHIPMENTS
];

export const rfidStatusTypes = [
  HOLD,
  QUEUED,
  PRINTING,
  PRINTED,
  COLLATING,
  COLLATED,
  LAMINATING,
  LAMINATED,
  CUT,
  VALIDATING,
  VALIDATED,
  PACKING,
  SHIPMENTS
];

export const shipmentStatusTypes = [
  NEW,
  READY,
  BOXED,
  SHIPPED,
  EOD_FAILED,
  // EOD_COMPLETED,
  CANCELLED
];

export const preferredCuttingTypes = [
  DIE,
  LASER,
  NONE
]
export const nextStatus = {
  // queued    : { next: PRINT_READY, url: `/dashboard/jobs/${PRINT_READY}`, icon: 'fa-clone', text: 'PRINT_READY_NEXT' },
  // printready: { next: PRINTED, url: `/dashboard/jobs/${PRINTED}`, icon: 'fa-file-image-o', text: 'PRINTED_NEXT' }, 
  printed   : { next: SHIPMENTS, url: `/dashboard/jobs/${SHIPMENTS}`, icon: 'fa-truck', text: 'SHIPPED_NEXT' }
}

export const nextOAStatus = {
  queued: { next: CUT, url: `/oa/dashboard/jobs/${CUT}`, icon: 'fa-cut', text: 'CUT_NEXT' },
  cut   : { next: PACKING, url: `/oa/dashboard/jobs/${PACKING}`, icon: 'fa-box', text: 'PACKING' },
  packing: { next: SHIPMENTS, url: `/oa/dashboard/jobs/${SHIPMENTS}`, icon: 'fa-truck', text: 'SHIPPED_NEXT' },
}

export const nextRFIDStatus = {
  queued: { next: PRINTING, url: `/rfid/dashboard/jobs/${PRINTING}`, icon: 'fa fa-print', text: 'PRINTING' },
  printing   : { next: PRINTED, url: `/rfid/dashboard/jobs/${PRINTED}`, icon: 'far fa-file-image', text: 'PRINTED' },
  printed   : { next: COLLATING, url: `/rfid/dashboard/jobs/${COLLATING}`, icon: 'fas fa-sliders-h', text: 'COLLATING' },
  collating: { next: COLLATED, url: `/rfid/dashboard/jobs/${COLLATED}`, icon: 'fa fa-tasks', text: 'COLLATED' },
  collated: { next: LAMINATING, url: `/rfid/dashboard/jobs/${LAMINATING}`, icon: 'fas fa-outdent', text: 'LAMINATING' },
  laminating: { next: LAMINATED, url: `/rfid/dashboard/jobs/${LAMINATED}`, icon: 'far fa-credit-card ', text: 'LAMINATED' },
  laminated: { next: CUT, url: `/rfid/dashboard/jobs/${CUT}`, icon: 'fa fa-cut', text: 'CUT' },
  // finishing: { next: FINISHED, url: `/rfid/dashboard/jobs/${FINISHED}`, icon: 'far fa-credit-card ', text: 'FINISHED' },
  cut: { next: VALIDATING, url: `/rfid/dashboard/jobs/${VALIDATING}`, icon: 'fa fa-text-width', text: 'VALIDATING' },
  validating: { next: VALIDATED, url: `/rfid/dashboard/jobs/${VALIDATED}`, icon: 'fa fa-check-square', text: 'VALIDATED' },
  validated: { next: PACKING, url: `/rfid/dashboard/jobs/${PACKING}`, icon: 'fab fa-dropbox', text: 'PACKING' },
  // finished: { next: PACKING, url: `/rfid/dashboard/jobs/${PACKING}`, icon: 'fab fa-dropbox', text: 'PACKING' },
  packing: { next: SHIPMENTS, url: `/rfid/dashboard/jobs/${SHIPMENTS}`, icon: 'fa fa-truck', text: 'SHIPPED_NEXT' },
}

export const nextBatchStatus = {
  open    : { next: SEALED, url: '/dashboard/batches/locked', icon: 'fa-lock', text: 'SEAL_BATCH' }
  // sealed  : { next: PRINTED, url: '/dashboard/jobs/printed', icon: 'fa-file-image-o', text: 'PRINTED_NEXT' }
  // printing: { next: PRINTED, url: '/dashboard/jobs/printed', icon: 'fa-file-image-o', text: 'PRINTED_NEXT' },
  // printed : { next: SHIPMENTS, url: '/dashboard/jobs/shipping', icon: 'fa-truck', text: 'SHIPPED_NEXT' }
};

export const allowJobScan = {
  'printed' : true,
  'printready' : true,
  'printing' : true,
  'shipping' : true,
  'cut'      : true
}

export const noDieRequiredTemplates = [
  '97222-02',
  '94128-02'
]

export const MARKETPLACEEMAILS : any = [
  'OAwalmartMP@avery.com',
  'OAamazonDF@avery.com',
  'OAgoogleMP@avery.com',
  'OAneweggcMP@avery.com',
  'OAneweggbMP@avery.com',
  'OAofficedepotDF@avery.com',
  'OAmichaelsMP@avery.com',
  'OAOrientalTradingMP@avery.com',
  'OAstaplesDF@avery.com',
  'OAstaplesCom@avery.com',
  'OAQuill@avery.com',
  'OATargetPlus@avery.com',
  'OABestBuy@avery.com',
  'OATikTokShop@avery.com'
]

export const MARKETPLACEEMAILS_MAPPING = {
  'oawalmartmp@avery.com'    : "Walmart",
  'oaamazondf@avery.com'     : "Amazon",
  'oagooglemp@avery.com'     : "Google",
  'oaneweggcmp@avery.com'    : "Newegg",
  'oaneweggbmp@avery.com'    : "Newegg",
  'oaofficedepotdf@avery.com': "Office Depot",
  'oamichaelsmp@avery.com'   : "Michaels",
  'oaorientaltradingmp@avery.com' : "Oriental Trading",
  'oaquill@avery.com'        : "Quill",
  'oastaplesdf@avery.com'    : "Staples",
  'oastaplescom@avery.com'   : "Staples",
  'oatargetplus@avery.com'   : "Target Plus",
  'oabestbuy@avery.com'      : "Best Buy",
}

export const rfidChipTypes = [
  'F08',
  'EV1',
  'ULC'
]


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/status-types.ts